import { lazy } from "react"

const AboutPage = lazy(() => import('../pages/AboutPage/AboutPage'));
const GalaryPage = lazy(() => import('../pages/GalaryPage/GalaryPage'));
const HomePage = lazy(() => import('../pages/HomePage/HomePage'));
const ServicesPage = lazy(() => import('../pages/ServicesPage/ServicesPage'));
const DesignWork = lazy(() => import('../pages/ServicesPage/DesignWork'));
const Documentation = lazy(() => import('../pages/ServicesPage/Documentation'));
const ElecrtricalnstPage = lazy(() => import('../pages/ServicesPage/ElecrtricalnstPage'));

export const publicRoutes = [
  { path: '/services', component: <ServicesPage />, name: 'Послуги', exact: true },
  { path: '/galary', component: <GalaryPage />, name: 'Галерея', exact: true },
  { path: '/about', component: <AboutPage />, name: 'Про нас', exact: true },
  { path: '/', component: <HomePage />, exact: true },
  { path: '/services/electrical-installation', component: <ElecrtricalnstPage />, exact: true },
  { path: '/services/documentation', component: <Documentation />, exact: true },
  { path: '/services/design-work', component: <DesignWork />, exact: true },
]
